var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.222,
    height: 104.688,
    viewBox: "0 0 204.222 104.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-116 -201.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delivery-man",
    transform: "translate(236.129 224.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M382.021,228.265h21.348v7.416a3.338,3.338,0,0,1-3.329,3.331h-7.679l-4.58,2.314-5.76-2.314V228.265Z",
    transform: "translate(-319.276 -193.143)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M385.351,162.742h14.691a3.338,3.338,0,0,1,3.329,3.331v5.511H382.022v-5.511A3.338,3.338,0,0,1,385.351,162.742Z",
    transform: "translate(-319.277 -138.381)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M382.022,206.463H403.37V211.7H382.022Z",
    transform: "translate(-319.277 -174.921)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M252.777,293.7h10.341v4.757a2.079,2.079,0,0,1-2.072,2.074H227.377c0-2.99,0-4.512,2.288-4.512l4.556,0c2.868,0,4.748-.739,5.8-2.314h12.757Z",
    transform: "translate(-190.032 -247.83)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M160.6,335.289h29.607c1.736,3.024,3.132,6.658,1.928,13.608-2.014-6.855-22.475-4.118-24.576,3.792H144.988c-.854-1.934-1.66-3.845-2.365-5.774h6.365C161.861,342.057,157.722,344.222,160.6,335.289Z",
    transform: "translate(-119.198 -282.589)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M237.09,132.918a48.327,48.327,0,0,0,1.712,6.562l6.508,2.55,7.257-2.55c-.254-13.733-5.386-20.319-9.751-22.45a10.6,10.6,0,0,0-3.185-1.649s-2.12,3.391-2.23,3.391a18.217,18.217,0,0,0-1.07,7.2Z",
    transform: "translate(-197.511 -98.799)",
    fill: "#dedede",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M229.192,262.108H215.427c-3.17.346-7.07,2.76-7.07,10.239v7.839l3.124,1.861,4.061-1.861v-6.058c0-2.99,0-4.512,2.288-4.512l4.556,0c2.868,0,4.748-.739,5.8-2.314A8.495,8.495,0,0,0,229.192,262.108Z",
    transform: "translate(-174.136 -221.427)",
    fill: "#6d8aa2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M294.474,376.333a12.551,12.551,0,0,1,24.576-3.792,12.873,12.873,0,0,1,.552,3.389c.014.461-.3.4-.734.4Q306.673,376.333,294.474,376.333Z",
    transform: "translate(-246.108 -306.232)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M313.718,441.231h19.128a9.569,9.569,0,0,1-19.128,0Z",
    transform: "translate(-262.192 -371.13)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M16.884,428.81,33.34,432.6a8.443,8.443,0,1,1-16.456-3.787Z",
    transform: "translate(-13.93 -360.749)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1.722,375.375a11.486,11.486,0,0,1,10.585-4.925c7.444,1.574,9.866,6.024,10.35,11.573a11.47,11.47,0,0,1-.254,2.271c-.048.211-.187.125-.417.072l-2.576-.59L2.954,379.988,1.722,379.7,0,379.306a11.4,11.4,0,0,1,1.722-3.931Z",
    transform: "translate(0 -311.927)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M74.845,246.761l6.648-23,2.993-1.339,3.348,1.339c-4.4,12.192-3.17,20.7-.2,28.825.71,1.93,1.516,3.84,2.365,5.774H85.215Z",
    transform: "translate(-62.552 -188.258)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M197.593,65.095l7.8-1.661c.791.072,3.055,1.973,3.055,3.163l-1.66,8.439a7.617,7.617,0,0,1-2.182.322,7.541,7.541,0,0,1-7.012-10.263Z",
    transform: "translate(-164.715 -55.384)",
    fill: "#ffd9c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M184.849,24.134a9.5,9.5,0,1,1,18.993,0,10.162,10.162,0,0,1-4.048,8.52,9.059,9.059,0,0,1-3.233,1.421V25.636c0-1.19-.6-1.43-1.4-1.5H184.849Z",
    transform: "translate(-154.489 -14.423)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M185.751,372.171h7.185V376.7c0,.97-.528,1.042-1.3,1.042H181.319C181.113,373.2,183.861,372.171,185.751,372.171Z",
    transform: "translate(-151.529 -313.413)",
    fill: "#6f6571",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M97.654,184.864l8.974,2.966c.441.394-.057,4.407-.355,4.277H95.841v-6.6C95.841,184.2,96.517,184.49,97.654,184.864Z",
    transform: "translate(-80.1 -156.606)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M154.676,207.1h-4.537c-2.437,0-2.509-4.042.355-4.277l4.182-.336,1.122,2.376Z",
    transform: "translate(-123.965 -171.599)",
    fill: "#ffd9c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M195.092,168.256l1.5-1.291c3.76-3.24,8.513,2.227,3.487,5.491l-4.23,2.746-2.13,1.382h-6.739v-4.613l4.187-.341Z",
    transform: "translate(-156.271 -141.082)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M238.536,219.771Z",
    transform: "translate(-198.957 -185.652)",
    fill: "#cbc7cb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 190,
    transform: "translate(121.5 304.098)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(105 198.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7454",
    "data-name": "Path 7454",
    d: "M81.872,38.7c0,30.991-35.436,61.985-35.436,61.985S11,69.695,11,38.7a35.436,35.436,0,1,1,70.872,0Z",
    transform: "translate(0 0)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 28.686,
    cy: 28.686,
    r: 28.686,
    transform: "translate(17.75 9.566)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535",
    transform: "translate(29.562 21.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7456",
    "data-name": "Path 7456",
    d: "M35.5,27.5c0,.317,0,.645-.982,1.136l-2.393,1.2V14H28.75V29.832l-2.393-1.2c-.982-.491-.982-.818-.982-1.136V14H22V27.5a4.556,4.556,0,0,0,2.847,4.154L28.134,33.3a5.062,5.062,0,0,0,.616.221V51.124h3.375V33.519a5.062,5.062,0,0,0,.616-.221l3.285-1.644A4.556,4.556,0,0,0,38.874,27.5V14H35.5Z",
    transform: "translate(-22 -14)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7457",
    "data-name": "Path 7457",
    d: "M50.874,24.125c0-5.585-3.78-10.125-8.437-10.125S34,18.539,34,24.125c0,4.894,2.9,8.981,6.75,9.92V51.124h3.375V34.045C47.974,33.105,50.874,29.018,50.874,24.125Z",
    transform: "translate(-13.751 -14)",
    fill: "#9a9a9a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus18);
export default __webpack_public_path__ + "static/media/status-18.398373e5810f7c12c80de2977eb043d2.svg";
export { ForwardRef as ReactComponent };